enum EnumRegistrationStatus {
    Created = "Created",
    Unpaid = "Unpaid",
    Paid = "Paid",
    Refunded = "Refunded",
    Deleted = "Deleted",
    Reserved = "Reserved"
}
export default EnumRegistrationStatus